import React from "react";

import { LoginRedirect } from "@src/domains/Redirects/LoginRedirect";
import { ShareRoute } from "@src/features/publicShareLinks/Share.route";
import { PUBLIC_ROUTES } from "@src/routes/routes";

import LoginPage from "../../components/Login/LoginPage";

export const GeneralPublicRoutes = [
  {
    path: PUBLIC_ROUTES.Login,
    element: <LoginRedirect />,
  },
  {
    path: "*",
    element: <LoginPage />,
  },
];
